import React from 'react';
import styles from '@/pages/decedent-details/styles.less';
import EditIcon from '@mui/icons-material/Edit';
import { useTranslation } from 'react-i18next';

const PrimaryUser = ({ user, openEdit }) => {
  const { t } = useTranslation();
  if (!user)
    return (
      <div className={styles.primary}>
        <div className={styles.primaryHeader}>
          <h3>{t('Primary User')}</h3>
        </div>
      </div>
    );

  const {
    firstName,
    lastName,
    middleName,
    email,
    homePhoneNumber,
    mobilePhoneNumber,
  } = user;
  return (
    <div className={styles.primary}>
      <div className={styles.primaryHeader}>
        <h3>{t('Primary User')}</h3>
      </div>
      <div className={styles.primaryBody}>
        <div className={styles.primaryInfo}>
          <div className={styles.primaryInfoText}>
            <span>{`${firstName} ${middleName} ${lastName}`}</span>
            <span>{email}</span>
          </div>
          <div className={styles.edit} onClick={openEdit}>
            <EditIcon /> {t('Edit')}
          </div>
        </div>
        {mobilePhoneNumber && (
          <div className={styles.primaryTel}>
            <span>{t('Tel. (mob):')}</span> <span>{mobilePhoneNumber}</span>
          </div>
        )}
        {homePhoneNumber && (
          <div className={styles.primaryTel}>
            <span>{t('Tel. (home):')}</span> <span>{homePhoneNumber}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PrimaryUser;
